import { Component, OnInit, forwardRef, Inject, Input, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslationService } from '../../../common/services/languages/translation.service';
import { AdminApiHandlerService } from '../../services/api-handler/api-handler.service';
import { Observable, Subscription } from 'rxjs';
import { select, NgRedux } from '@angular-redux/store';
import { AppState } from '../../../store/state.model';
import { CustomerState } from '../../../store/customer/customer-state.model';
import { ApiResponseState } from '../../../store/api-response/api-response-state.model';
import { CustomerDispatcher } from '../../../store/customer/customer-dispatcher';
import { OrchestrationService } from '../../services/orchestration-service/orchestration.service';
import { ApiResponseDispatcher } from '../../../store/api-response/api-response-dispatcher';
import { AdminDispatcher } from '../../../store/admin-store/admin-dispatcher';
import { SidenavService } from '../../services/sidenav.service';
import { ApiResponseActions } from '../../../store/api-response/api-response-actions';
import { NgIf } from '@angular/common';
import { CustomerComponent } from '../../customer/customer.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-result-customer',
    templateUrl: './result-customer.component.html',
    styleUrls: ['./result-customer.component.scss'],
    imports: [NgIf, CustomerComponent, TranslatePipe]
})
export class ResultCustomerComponent implements OnInit, OnDestroy {
  /**
  * Property to observe the redux customer store
  **/
  @select('customer') readonly customerObservable: Observable<CustomerState>;
  /**
  * Property to observe the redux admin store
  **/
  @select('admin') readonly adminObservable: Observable<any>;
  /**
  * Property to determine customer not found error
  **/
  public customerNotFoundError: boolean;
  /**
  * Property to determine mode
  **/
  public mode: string;
  /**
  * Property to store customer information
  */
  public customerData: any;
  /**
  * Property to observe the redux customer store
  **/
  @select('api') readonly apiObservable: Observable<ApiResponseState>;
  /**
  * Property to store params loke mode and phone
  **/
  @Input() public params: object;
  /**
   * @property to store the subscriptions
   */
  private apiSubscription: Subscription;
  private customerSubscription: Subscription;
  private adminSubscription: Subscription;
  /**
   * Flag to track if customer history side nav has been opened
   */
  private customerHistorySideNavOpened: boolean = false;
  constructor(
    @Inject(forwardRef(() => AdminApiHandlerService)) public apiHandler: AdminApiHandlerService,
    public route: ActivatedRoute,
    public translate: TranslationService,
    public reduxState: NgRedux<AppState>,
    public customerDispatcher: CustomerDispatcher,
    public orch: OrchestrationService,
    public apiDispatcher: ApiResponseDispatcher,
    private adminDispatcher: AdminDispatcher,
    private sidenav: SidenavService

  ) {
    this.customerSubscription = this.customerObservable.subscribe((customer) => {
      this.customerNotFoundError = customer.error_customer_not_found;
      this.customerData = customer;
    });
    this.apiSubscription = this.apiObservable.subscribe((api) => {
      if (api.apiAction === ApiResponseActions.SET_CUSTOMER_HISTORY) {
        if (api.customerHistory['type'] === 'success' && !!api.customerHistory['payload']['customerHistory']) {
          if (!this.customerHistorySideNavOpened) {
            this.customerHistorySuccess();
          }
        } else if (api.customerHistory['type'] === 'error') {
          this.customerHistoryError(api.customerHistory);
        }
      }
    });
    this.adminSubscription = this.adminObservable.subscribe((admin) => {
      if (admin.UpdateType === '' || (admin.UpdateType !== 'customer-history' && this.customerHistorySideNavOpened)) {
        this.customerHistorySideNavOpened = false;
      }
    });
  }
  /**
   * @function ngOnInit Method to Initializes the component and perform initial operations which subscribes to route
   */
  ngOnInit(): void {
  }

  /**
   * @function ngOnDestroy Runs final sequence
   */
  ngOnDestroy() {
    this.customerSubscription.unsubscribe();
    this.apiSubscription.unsubscribe();
    if (this.adminSubscription) {
      this.adminSubscription.unsubscribe();
    }
  }
  /**
 * @function getCustomerHistory gets the subscription history of the account
 * @param vin Vin number of the vehicle
 */
  public getCustomerHistory(): void {
    this.customerHistorySideNavOpened = false;
    const customerEmail = this.customerData['data']['emails'][0]['emailAddress'];
    this.orch.getCustomerHistory(customerEmail, 1, 10);
  }
  /**
  * @function displayResults Determines to display result or not
  **/
  public displayResults(): boolean {
    const customerData = this.customerData && this.customerData.data;
    const isEmptyCustomer = !!customerData && Object.entries(customerData).length === 0 && customerData.constructor === Object;
    return (!isEmptyCustomer);
  }
  /**
   * @method customerHistorySuccess will enable the customer history side nav
   **/
  public customerHistorySuccess(): void {
    const customerEmail = this.customerData['data']['emails'][0]['emailAddress'];
    this.customerHistorySideNavOpened = true;
    this.adminDispatcher.setUpdateInfo('customer-history', 'customer-history', 'customer-history', '', { customerEmail });
    this.sidenav.toggle();
    window.scrollTo(0, 0);
  }
  /**
* @function customerHistory Action after an error from API response
* @arg customerHistoryError object
* @returns void
**/
  public customerHistoryError(customerHistoryError: object): void {
    this.apiDispatcher.setCustomerHistoryResponse({});
  }
}

